// extracted by mini-css-extract-plugin
module.exports = {"chart":"PieChart_chart__2VhCp","text":"PieChart_text__auUM_","circle":"PieChart_circle__2eW7d"};